import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import {
  createBadgeBlock,
  createButtonBlock,
  createH2Block,
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import {
  getHeightOptions,
  getWidthOptions,
} from "../../../utils/sizeStyleHelpers";
import bookImagePlaceholder from "../../CallToAction/CardCallToAction/book_image_placeholder.png";
import userImagePlaceholder from "../../CallToAction/CardCallToAction/user_image_placeholder.png";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import { getSalesBlockSecondaryStyleOptions } from "../constants";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: bookImagePlaceholder,
    },
    title: "Clarity & Vision",
    badge: "Phase 1: Week 1-4",
    description:
      "Discover your authentic values, strengths, and purpose to create a compelling vision for your future.",
  },
  {
    image: {
      signedId: "",
      placeholder: userImagePlaceholder,
    },
    title: "Strategy & Mindset",
    badge: "Phase 2: Week 5-8",
    description:
      "Develop a personalized roadmap and overcome the limiting beliefs that have held you back.",
  },
];

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock4_2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Introducing: The Breakthrough Method™",
        }),
        createPBlock({
          text: "A 12-week transformational coaching program designed to help you achieve clarity, confidence, and consistent results.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(({ image, title, badge, description }) => {
        const value = [
          createImageBlock({
            signedId: image.signedId,
            placeholder: image.placeholder,
            styles: {
              width: getWidthOptions({
                defaultValue: "3.375rem",
              }),
              height: getHeightOptions({
                defaultValue: "3.375rem",
              }),
              borderRadius: getBorderRadiusOptions({
                defaultValue: {
                  border_left_top_radius: 100,
                  border_left_bottom_radius: 100,
                  border_right_top_radius: 100,
                  border_right_bottom_radius: 100,
                },
              }),
            },
          }),
          createH5Block({
            text: title,
          }),
          createBadgeBlock({
            text: badge,
          }),
          createPBlock({
            text: description,
          }),
        ];
        return createCardBlock({ value });
      }),
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Join the community",
          href: "#",
          buttonType: "primaryButton",
        }),
        createPBlock({
          text: "This proven methodology has helped hundreds of professionals achieve breakthrough results in their careers and lives.",
          paragraphStyle: "p3",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
    },
  },
};
